import styles from './CostAndTimeTable.module.scss';
import classNames from 'classnames';
import { FC, CSSProperties } from 'react';

const labelColumnWidth = 70;

/**
 * 行を@で、列を&で区切った文字列を成形する
 * Form a string with rows separated by @ and columns separated by &.
 * for example
 * お客さまの利用目的&彼女の誕生日を祝いたい&独りのクリスマスを少しでも豪華にしたい&パワー溢れる料理を食べたい@
 * コース内容&見た目がおしゃれな料理を作ります&「孤独」と「豪華」をテーマにした、牛フィレ肉のトリュフかけをメインに添えて、シェフからの温かい励ましの言葉があります。@
 * 利用人数&2人&1人&6人@
 * 料金&63,000円&5,000円
 */

const createListForDisplay = (str: string): Array<{ label: string; valueList: Array<string> }> => {
  // まず行の配列にする First, make an array of rows 1@2@3@4 -> [1,2,3,4]
  const rowList = str.replace(/\r?\n/g, '').split('@');
  // 列で区切る delimit by columns 1-1&1-2&1-3&1-4 -> 1-1,1-2,1-3,1-4
  const columnList = rowList.map((row) => row.split('&'));
  // オブジェクトの配列へ成形する Molding into an array of objects [[1-1,1-2,1-3,1-4]] => [{label: 1-1, valueList: [1-2,1-3,1-4]}]
  return columnList.map((column) => {
    let label = column.shift();
    // 型ガードtype guard
    if (label === undefined) {
      label = '';
    }
    const valueList = [...column];
    return {
      label,
      valueList,
    };
  });
};

interface Props {
  CTTableInfo: string;
}

const valueRowStyleGenerator = (columnCount: number): CSSProperties => ({
  background: '#fff',
  border: '1px solid #c4c4c4',
  color: '#2f2f2f',
  fontSize: '14px',
  fontStyle: 'normal',
  fontWeight: 'bolder',
  padding: '9px 16px',
  width: `${labelColumnWidth / columnCount}%`,
});

const CostAndTimeTable: FC<Props> = ({ CTTableInfo }) => {
  const displayList = createListForDisplay(CTTableInfo);
  const [firstColumn] = displayList;
  const columnCount = firstColumn.valueList.length;

  return (
    <div className={styles['basic-CTinfo-container']}>
      {displayList.map((costAndTimeInfo, tableIndex) => (
        // eslint-disable-next-line react/no-array-index-key
        <div className={styles['basic-CTinfo-table']} key={`table-${tableIndex}`}>
          <div
            className={classNames(styles['basic-CTinfo-table-cell'], styles['basic-CTinfo-label'])}
          >
            {costAndTimeInfo.label}
          </div>
          {costAndTimeInfo.valueList.map((value, valueIndex) => (
            <div
              // eslint-disable-next-line react/no-array-index-key
              key={`value-${tableIndex}-${valueIndex}`}
              style={valueRowStyleGenerator(columnCount)}
            >
              {value}
            </div>
          ))}
        </div>
      ))}
    </div>
  );
};

export { CostAndTimeTable };
